// extracted by mini-css-extract-plugin
module.exports = {"flexBox":"ShutdownForm_flexBox__1ATfJ"};